export default __webpack_public_path__ + "resources/icons/d340-5de3.webp";